import { render, staticRenderFns } from "./PrivacyOfficer.vue?vue&type=template&id=59d97d52&"
import script from "./PrivacyOfficer.vue?vue&type=script&lang=js&"
export * from "./PrivacyOfficer.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyOfficer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports